import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/operated/pointRecord',
  owner: '/home',
  authority: 'pointRecordList',
  component: Loadable({
    loader: () => import('.'),
    loading: () => <RouteLoading />
  })
};